import { Card } from '@blueprintjs/core';
import { WorkQueue } from '../../../components/WorkQueue';

interface Props {
  marketCountry: string;
}

export function WorkQueuesTab({ marketCountry }: Props) {
  return (
    <Card>
      <WorkQueue marketCountry={marketCountry} />
    </Card>
  );
}
